import { render, staticRenderFns } from "./ReportLaneClosureRequestBlockSidewalkListing.vue?vue&type=template&id=63e5a376&"
import script from "./ReportLaneClosureRequestBlockSidewalkListing.vue?vue&type=script&lang=js&"
export * from "./ReportLaneClosureRequestBlockSidewalkListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports